import * as React from "react";
var TemplateArea = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: className }, children));
};
export default TemplateArea;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/template/templateArea.tsx
// module id = vqre
// module chunks = 2